import React from "react";
import { useForm } from "react-hook-form";
import { authService } from "@shared/ui";
import { useTranslation } from "react-i18next";

type FormValues = {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

const ChangePasswordForm: React.FC<{userId: number, setChangePassModal: (value: boolean) => void}> = ({userId, setChangePassModal}) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormValues>();

  const newPassword = watch("newPassword");

  const onSubmit = (data: FormValues) => {
    authService.changeOwnPassword(data.oldPassword, data.newPassword, data.confirmPassword).then((data: boolean) => {
      if (data){
        setChangePassModal(false);
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <label htmlFor="password">{t("changePasswordForm.labels.oldPassword")}</label>
        <input
          id="password"
          type="password"
          {...register("oldPassword", {
            required: t("changePasswordForm.errors.oldPasswordRequired"),
          })}
        />
        {errors.oldPassword && <span className="error">{errors.oldPassword.message}</span>}
      </div>

      <div>
        <label htmlFor="new-password">{t("changePasswordForm.labels.newPassword")}</label>
        <input
          id="new-password"
          type="password"
          {...register("newPassword", {
            required: t("changePasswordForm.errors.newPasswordRequired"),
            validate: (value, formValues) =>
              value !== formValues.oldPassword ||
              t("changePasswordForm.errors.newPasswordSameAsOld"),
          })}
        />
        {errors.newPassword && <span className="error">{errors.newPassword.message}</span>}
      </div>

      <div>
        <label htmlFor="confirm-password">{t("changePasswordForm.labels.confirmPassword")}</label>
        <input
          id="confirm-password"
          type="password"
          {...register("confirmPassword", {
            required: t("changePasswordForm.errors.confirmRequired"),
            validate: (value) =>
              value === newPassword || t("changePasswordForm.errors.passwordsMismatch"),
          })}
        />
        {errors.confirmPassword && <span className="error">{errors.confirmPassword.message}</span>}
      </div>

      <input type="submit" value={t("changePasswordForm.submit")} />
    </form>
  );
};

export default ChangePasswordForm;
